const mapKeys = (arr) => {
	let newObj = {};
	arr.forEach((key) => {
		newObj[key] = key;
	});
	return { ...newObj };
};

export default mapKeys;
